import { type Actor, checkCanConfirm } from '@dc1/shared';

/** Avatar initials: first letter of the first and the last word ("Lê Thu Hà" → "LH"). */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const first = words[0]?.[0] ?? '';
  const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}

/**
 * Levels waiting for a confirmation that `actor` may give, and how many people they belong to: never their
 * own, and only Members' for a Sub-Leader (`checkCanConfirm` in @dc1/shared). The nav badge and the
 * dashboard KPI count these, as design v3 does.
 */
export function confirmablePending(
  actor: Actor,
  people: readonly (Actor & { pendingCount: number })[],
): { levels: number; people: number } {
  const mine = people.filter((p) => p.pendingCount > 0 && checkCanConfirm(actor, p).ok);
  return { levels: mine.reduce((n, p) => n + p.pendingCount, 0), people: mine.length };
}
